import React, { FC } from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'

import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Box } from '@ucheba/ui/components/Box/desktop'

import { sv } from '@ucheba/utils/helpers/styles/variables'
import { eventsSearchSelectors } from '@ucheba/store/events/search'
import { useSelector } from 'react-redux'
import calendarImage from '../../assets/calendarImage.png'
import { useEventsListItemDate } from '../../../../../../../components/EventsList/bll'

const Dot = styled.span`
  margin: 0 4px;
  color: ${sv.color.coffee25};
`

const ButtonStyled = styled(Button)`
  width: 146px;
`

const Row = styled.div`
  display: flex;
  align-items: center;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: auto;
  padding-right: 16px;
`

const BoxStyled = styled(Box)`
  display: flex;
`

const AnnouncementOfNextEvent: FC = () => {
  const { push } = useRouter()

  const { items, total } = useSelector(eventsSearchSelectors.entity) || {}

  const { format, date } = useEventsListItemDate(items?.[0])

  const { name, institution, id } = items?.[0] || {}

  if (!total) return null

  return (
    <>
      <BoxStyled spacing='small' color='gold'>
        <Content>
          <Row>
            <Row>
              {(date || format) && (
                <Text
                  as='span'
                  fontWeight='semibold'
                  fontSize='h5'
                  lineHeight='h4'
                  color='coffee'
                  spacing='null'
                  html={false}
                >
                  {date}

                  {date && format && (
                    <Text color='coffee25' as='span'>
                      {' • '}
                    </Text>
                  )}

                  {format}
                </Text>
              )}
            </Row>
          </Row>

          <Spacing spacing='usmall' />

          <Row>
            <Text
              as='span'
              fontWeight='semibold'
              fontSize='h4'
              lineHeight='h4'
              color='coffee'
              spacing='usmall'
            >
              {institution?.name}
            </Text>

            <Dot>•</Dot>

            <Text
              as='span'
              fontWeight='semibold'
              fontSize='h4'
              lineHeight='h4'
              color='coffee60'
              spacing='usmall'
            >
              {institution?.location?.name}
            </Text>
          </Row>

          <Spacing spacing='usmall' />

          <Text
            fontWeight='bold'
            fontSize='h3'
            lineHeight='h3'
            color='orange'
            spacing='null'
          >
            {name}
          </Text>

          <Spacing spacing='xxsmall' />

          <ButtonStyled
            color='orange'
            onClick={() => push(`/for-abiturients/events/${id}`)}
          >
            Участвовать
          </ButtonStyled>
        </Content>

        <img width='79px' height='95px' src={calendarImage} alt='calendar' />
      </BoxStyled>

      <Spacing spacing='xlarge' />
    </>
  )
}

export default AnnouncementOfNextEvent
